var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({attrs:{"outlined":"","hide-details":"auto","rules":[_vm.rules.contactCredentials(_vm.entity), _vm.rules.optionalEmail]}},'v-text-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }